import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from "@/shared"


type GetCacheProps = {
  key: string;
  value: Record<string, any> | null;
};

const { post, get } = erpApi();

export const postCache = (data: GetCacheProps) => {
  const resp = post<GetCacheProps>(`${urlBackend}api/v1/set-cache/`, data, true);
  return resp;
};

export const getCache = async (key: string) => {
  const resp = await get<Record<string, any>>(`${urlBackend}api/v1/get-cache/?key=${key}`, true);
  return resp;
};
